import React from 'react';
import TextField from '@mui/material/TextField';

export default function AppMonthField({
  helperText = 'MM/YYYY',
  InputLabelProps,
  inputProps,
  FormHelperTextProps,
  ...props
}) {
  return (
    <TextField
      {...props}
      type="month"
      helperText={helperText}
      InputLabelProps={{ shrink: true, ...(InputLabelProps || {}) }}
      inputProps={{ lang: 'en-GB', ...(inputProps || {}) }}
      FormHelperTextProps={{ sx: { mt: 0.5 }, ...(FormHelperTextProps || {}) }}
    />
  );
}
